import { render, staticRenderFns } from "./QuantityCard.vue?vue&type=template&id=510d52c4&"
import script from "./QuantityCard.vue?vue&type=script&lang=js&"
export * from "./QuantityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports